import getPBracketsCDNURL from '@pickleballinc/ui/components/global/utils/getPBracketsCDNURL';

import { SponsorLevelWithSponsors } from '@/entities/Sponsor';

interface SponsorsSectionProps {
	sponsorLevel: SponsorLevelWithSponsors;
	isSponsorsPage?: boolean;
}

export const SponsorsSection = ({ sponsorLevel, isSponsorsPage }: SponsorsSectionProps) => {
	return (
		<div className={`flex flex-col gap-4 rounded-lg bg-white ${isSponsorsPage && 'p-8'}`}>
			<div className={`rounded-t-lg text-lg font-bold text-darkorange-600 ${isSponsorsPage ? 'sm:text-2xl' : 'p-2 bg-darkorange-100'}`}>
				{sponsorLevel.sponsorLevelTitle}
			</div>

			<div
				className={`${
					isSponsorsPage
						? 'grid grid-cols-2 gap-4 sm:grid-cols-3 xl:grid-cols-5'
						: 'grid grid-cols-2 gap-4 p-4 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3'
				}`}
			>
				{sponsorLevel.systemSponsors.map((sponsor) => (
					<div key={sponsor.uuid}>
						{sponsor.url ? (
							<a href={sponsor.url}>
								<img
									src={getPBracketsCDNURL(sponsor.logoUrl, 250, 250)}
									alt={`${sponsor.title} logo`}
									className={`w-full rounded-lg border bg-white object-contain p-2 ${isSponsorsPage && 'h-[128px]'}`}
								/>
							</a>
						) : (
							<img
								src={getPBracketsCDNURL(sponsor.logoUrl, 250, 250)}
								alt={`${sponsor.title} logo`}
								className={`w-full rounded-lg border bg-white object-contain p-2 ${isSponsorsPage && 'h-[128px]'}`}
							/>
						)}
					</div>
				))}
			</div>
		</div>
	);
};
